// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__273so","range":"MonthRangeSwitch_range__3QROo","disabled":"MonthRangeSwitch_disabled__30YGM"};